/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

/**
 * @namespace Phaser.Display
 */

module.exports = {

    Align: require('./align'),
    Bounds: require('./bounds'),
    Canvas: require('./canvas'),
    Color: require('./color'),
    Masks: require('./mask')
  
};



//////////////////
// WEBPACK FOOTER
// ./display/index.js
// module id = 488
// module chunks = 0